import { Trans } from '@lingui/macro';

export const RouterFallback = () => {
  return (
    <Trans>
      You do not have access to the requested page. Contact a company admin to get access.
    </Trans>
  );
};
